/* unplugin-vue-components disabled */import { render } from "./title.vue?vue&type=template&id=19311b34&scoped=true"
const script = {}

import "./title.vue?vue&type=style&index=0&id=19311b34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19311b34"]])

export default __exports__